import { routes as portfolioRoutes } from './portfolio';

export const routes = () => portfolioRoutes();
